$(function(){

	
	$('.js_copy').click(function() {
			var url = window.location.href;

			// テキストエリアを作成してURLをその中にコピーする
			var textarea = $('<textarea>');
			textarea.val(url);
			$('body').append(textarea);
			textarea.select();
			document.execCommand('copy');
			textarea.remove();

			// コピー完了メッセージを表示する（任意）
			alert('URLをコピーしました');
	});
		
	$('a[href*=\\#]:not([href=\\#],.comPopBtn)').on('click',function() {
		
		if($(this).attr("class") != "notjs") {
			
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var $target = $(this.hash);
				$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
				if ($target.length) {
					if($(this).parents('.menuBox').length){
						setTimeout(function(){
							var targetOffset = $target.offset().top;
							$('html,body').animate({scrollTop: targetOffset}, 1000);
						},100);
					}else{
						var targetOffset = $target.offset().top;
						$('html,body').animate({scrollTop: targetOffset}, 1000);
					}
					return false;
				}
			}

		}
	});
	// $('a').on('click',function() {
	// 	if($(this).find('.iconImg').length){
	// 		$(this).find('.iconImg').toggleClass('on');
	// 		return false;
	// 	}
	// });
	
	$(window).scroll(function(){
		if($(window).scrollTop()){
			$('#gHeader').addClass('fix');
		}else{
			$('#gHeader').removeClass('fix');
		}
	});
	
	$('#gHeader .subBox .searchBox').on('click',function(){
		$(this).addClass('on');
	});
	$('#gHeader .subBox .lauBox .top a').on('click',function(){
		$(this).toggleClass('on');
		$('#gHeader .subBox .lauBox .lauList').stop().fadeToggle();
		return false;
	});
	$(window).on('scroll',function(){
		var scroll = $(window).scrollTop();
		if(scroll > 10){
			$('#gHeader').addClass('hasBg'); 
		}else{
			$('#gHeader').removeClass('hasBg');
		}
	});
	$('#gNavi > ul > li:not(.link)').hover(function(){
		var num = $(this).index();
		$('.menuInner').eq(num).fadeIn();
	},function(){
		var num = $(this).index();
		$('.menuInner').eq(num).hide();
	});

	$('.menuBox .ulBox').each(function(){
		var simpleBar = new SimpleBar($(this)[0],{
			autoHide: false
		});
	});
	if(window.innerWidth < 768){
		$('.menuBox .ulBox').css('height',window.innerHeight - 209);
		$('.menuBox.luxeon .ulBox').css('height',window.innerHeight - 288);
		
	}

	$('.menuBox .subBox .lauBox a').on('click',function(){
		$(this).toggleClass('on');
		$('.menuBox .subBox .lauBox .lauList').stop().fadeToggle();
	});
	$('.menuBox .spNavi > li .infoNavi').hide();
	$('.menuBox .spNavi > li .brandSpList').hide();

	$('.menuBox .spNavi > li > a').on('click',function(){
		if($(this).next('ul').length){
			$(this).toggleClass('on');
			$(this).next('ul').stop().slideToggle();
			$(this).siblings('.brandSpList').stop().slideToggle();
			return false;
		}
	});
	
	var state = false;
	var scrollpos;
	$('.menu,.menuCover').on('click', function(){
		if(state == false) {
			scrollpos = $(window).scrollTop(); 
			$('body').addClass('fixed').css({'top': -scrollpos}); 
			$('.menuBox,.menuCover').stop().fadeIn();
			$('.menu').addClass('on');
			state = true;
		} else {
			$('body').removeClass('fixed').css({'top': 0});
			window.scrollTo( 0 , scrollpos ); 
			$('.menuBox,.menuCover').stop().fadeOut();
			$('.menu').removeClass('on');
			$('.menuBox .subBox .lauBox a').removeClass('on');
			$('.menuBox .subBox .lauBox .lauList').hide();
			state = false;
		}
		return false;
	});
	
	if($('.comService').length){
		if(window.innerWidth > 767){
			$('.comService .linkList li .comLine').matchHeight({
				byRow: false,
			});
		}else{
			$('.comService .linkList li .comLine').matchHeight();
		}
    }
	
	if($('.comService').length){
		$(".comFaq .whiteBox .qaList li .qTxt").click(function(){
			$(this).toggleClass("on");
			$(this).next(".aTxt").stop().slideToggle(300);
			return false;
		});
	}
	if($('.comPcSlideJs').length){
		$('.comPcSlideJs').each(function(){
			if(window.innerWidth > 767){
				if($(this).data('pcslide')){
					var num = parseInt($(this).data('pcslide'));
				}else{
					var num = 1;
				}
				$(this).slick({
					arrows: true,
					slidesToShow: num,
					variableWidth: true,
				});
			}
		})
	}
	if($('.comSpSlideJs').length){
		$('.comSpSlideJs').each(function(){
			if(window.innerWidth <= 767){
				if($(this).data('spslide')){
					var num = parseInt($(this).data('spslide'));
				}else{
					var num = 1;
				}
				$(this).slick({
					arrows: true,
					slidesToShow: num,
					variableWidth: true,
				});
			}
		})
	}
	
	// if($('.comPcSlideJsRecent').length){
	// 	$('.comPcSlideJsRecent').each(function(){
	// 	  if(window.innerWidth <= 767){
	// 		if($(this).data('pcslide')){
	// 		  var num = parseInt($(this).data('pcslide'));
	// 		}else{
	// 		  var num = 1;
	// 		}
	// 		$(this).slick({
	// 		  arrows: true,
	// 		  slidesToShow: num,
	// 		  variableWidth: true,
	// 		});
	// 	  }
	// 	})
	//   }
	//   if($('.comSpSlideJsRecent').length){
	// 	  $('.comSpSlideJsRecent').each(function(){
	// 		if(window.innerWidth <= 767){
	// 		  if($(this).data('spslide')){
	// 			var num = parseInt($(this).data('spslide'));
	// 		  }else{
	// 			var num = 1;
	// 		  }
	// 		  $(this).slick({
	// 			arrows: true,
	// 			slidesToShow: num,
	// 			variableWidth: true,
	// 		  });
	// 		}
	// 	  })
	// 	}
	if($('.popslideUl').length){
		$('.popslideUl').each(function(){
			$(this).slick({
				arrows: true,
				dots: true,
			});
		})
	}

	var scrollpos;
    $('.comPopBtn').magnificPopup({
        type: 'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 150,
        showCloseBtn: false,
        callbacks: {
            open: function() {
                scrollpos = $(window).scrollTop(); 
                $('body').addClass('fixed').css({'top': -scrollpos});
				if($('.popslideUl').length){
					$('.popslideUl').slick('setPosition');
				}
                comPopupContent = $(this.container).find('.mfp-content');
                comPopupContentHeight = comPopupContent.height();
                console.log($(window).innerHeight(), comPopupContentHeight);
                if ($(window).innerHeight() < comPopupContentHeight) {
                  comPopupContent.css({ 'height': 90 + '%' } );
                  comPopupContent.css({ 'overflow-y': 'scroll' } );
               }
            },
            close: function() {
                $('body').removeClass('fixed').css('top',0);
                window.scrollTo( 0 , scrollpos );
            }
        }
    });
	
	$('.comPop .close a,.popSec .close a,.slidePop .close a').on('click',function(){
		$.magnificPopup.close();
		return false;
	})

	if($('.comTabJs').length){
		$('.comTabJs').each(function(){
			var $this = $(this);
			$this.find('.comTabJsInner').hide().eq(0).show();
            // var $jsBlandBtn = $this.parent().find(".js_brand_list");
            var $jsFairBtn = $this.parent().find(".js_fair_list");
			var $jsNewsBtn = $this.parent().find(".js_news_list");
			$this.find('.comTabJsList a').on('click',function(){
				var num = $(this).parent().index();
				if(num == 0) {
					// $jsBlandBtn.attr("href","/pages/watch-brand-list");
					$jsFairBtn.attr("href","/blogs/fair");
					$jsNewsBtn.attr("href","/blogs/news");
				} else if(num == 1) {
					// $jsBlandBtn.attr("href","/pages/jewelry-brand-list");
					$jsFairBtn.attr("href","/blogs/fair/tagged/watch");
					$jsNewsBtn.attr("href","/blogs/news/tagged/watch");
				} else if(num == 2) {
					// $jsBlandBtn.attr("href","/pages/bridal-brand-list");
					$jsFairBtn.attr("href","/blogs/fair/tagged/jewelry");
					$jsNewsBtn.attr("href","/blogs/news/tagged/jewelry");
				} else if(num == 3) {
					// $jsBlandBtn.attr("href","/pages/eyewear-brand-list");
					$jsFairBtn.attr("href","/blogs/fair/tagged/bridal");
					$jsNewsBtn.attr("href","/blogs/news/tagged/bridal");
				} else if(num == 4) {
					// $jsFairBtn.attr("href","/blogs/fair/tagged/eyewear");
					$jsNewsBtn.attr("href","/blogs/news/tagged/eyewear");
				}
				$this.find('.comTabJsList li').removeClass('on').eq(num).addClass('on');
				$this.find('.comTabJsInner').hide().eq(num).show();
				if($this.find('.slick-slider').length && window.innerWidth > 896){
					$this.find('.slick-slider').slick('setPosition');
				}
				return false;
			});
		})
	}

	if($('.comShop').length){
		$('.comShop').each(function(){
			var $this = $(this);
			const swiper = new Swiper('.swiper', {
				slidesPerView: "auto",
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true,
					edgeSwipeThreshold: 100,
				},
				navigation: {
					nextEl: '.comShop .next',
					prevEl: '.comShop .prev',
				},
				pagination: {
					el: ".comShop .topBox .num",
					type: "fraction",
				},
              breakpoints: {
                768: {
                  slidesOffsetAfter: 470,
                }
              }
			});
		})
	}

	
	var pcflag,spflag;
	if(window.innerWidth > 768){
		pcflag = 1;
		spflag = 0;
	}else{
		pcflag = 0;
		spflag = 1;
	}
	
	$(window).resize(function(){
		if(window.innerWidth <= 768){
			if(pcflag){
				setTimeout(function(){window.location.reload()},100);
				pcflag = 0;
				spflag = 1;
			}
		}else{
			if(spflag){
				setTimeout(function(){window.location.reload()},100);
				pcflag = 1;
				spflag = 0;
			}
		}
	});
    $('.page-top').each(function(){
		if(window.innerWidth <= 767){
			var fixedBtnHeight = 0;
			if($('.spBtnCar').length && !$(".spBtnCar").hasClass("bridal")) {
				// var fixedBtnHeight = $('.spBtnCar').height();
                var fixedBtnHeight = 92;
			} else if ($('.comFixed').length) {
				var fixedBtnHeight = $('.comFixed').height();
			}
			$(this).css({ 'bottom': fixedBtnHeight + 48 + 10 + "px"});
		}
	});

    var pageTop = $('.page-top');
	$(window).scroll(function () {
		var scroll = $(this).scrollTop();
		if(scroll > 0) {
			pageTop.addClass('is-show');
		} else {
			pageTop.removeClass('is-show');
		}
	});

	$('.passwordIcon').on('click', function() {
		var pass = $("#password").attr('type');
		console.log(pass);
		if (pass === "text") {
			$("#password").attr('type', 'password');
			$(this).removeClass('is-show');
		} else {
			$("#password").attr('type', 'text');
			$(this).addClass('is-show');
		}
	});

    $('a[href="#shopify-product-reviews"]').on('click', function() {
		var $target = $(".spr-form");
		$target.show();
	});
	if($('.loanBtn').length){
		if(window.innerWidth <= 767){
			$(".result").show();
			$("#t1").text("0 円");
			// $("#t2").text(formatNumber(productPrice) + " 円");
			$("#t2").text("0 円");
			$("#t3").text("0 円");
			$("#t4").text("0 円");
			$("#t5").text("0 円");
		}
		$(".loanBtn a").click(function() {
			// 商品金額と回数を取得
			var productPrice = parseInt($(".loanPrice").val().replace(/,/g, ""), 10);
			var usage = parseInt($(".usage").val(), 10);
			var usageSec = usage - 1;

			// ローンシミュレーションの計算
			var firstPayment, subsequentPayment;
			$calc = productPrice / usage;
			// console.log($calc);
			if ($calc < 3000) {
				// 商品金額を回数で割った値が3,000を下回る場合
				var a = Math.floor(productPrice / 3000);
                usageSec = (a - 1);
				firstPayment = productPrice - (3000 * usageSec);
				// console.log(a, firstPayment);
				subsequentPayment = 3000;
			} else {
				var a = Math.floor(productPrice / usage / 100) * 100;
				var c = Math.round(a / 100) * 100;
				var b = productPrice - (c * usageSec);
				firstPayment = b;
				subsequentPayment = c;
			}

			// 更新結果を表示
			$("#t1").text(formatNumber(productPrice) + " 円");
			$("#t2").text("0 円");
			$("#t3").text(formatNumber(productPrice) + " 円");
			$("#t4").text(formatNumber(firstPayment) + " 円 (×1回)");
			$("#t5").text(formatNumber(subsequentPayment) + " 円 (×"+usageSec+"回)");

			// 結果の表示を切り替え
			$(".result").show();
		});
		function formatNumber(number) {
			// 数値を3桁ごとにカンマ区切りでフォーマット
			return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	};
});

$(window).on('load',function(){
	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){	
		localLink = localLink.slice(localLink.indexOf("#")+1);
		$('html,body').animate({scrollTop: $('#'+localLink).offset().top}, 500);
	}

    var shopTitleBoxHeightList = new Array();
	$('.comShopList > li .ttlBox').each(function(index){
		shopTitleBoxHeightList[index] = $(this).height();
	});
	var shopTitleBoxMaxHeight = Math.max.apply(null, shopTitleBoxHeightList);
	$('.comShopList > li .ttlBox').css({ 'height': shopTitleBoxMaxHeight + "px" });
    if(window.innerWidth <= 767){
		$('.spComTab > .comTabUl').each(function(){
			var commonTabUIWidthList = new Array();
			$(this).children().each(function(index){
				commonTabUIWidthList[index] = $(this).width();
			});
			var commonTabUIWidthSum = commonTabUIWidthList.reduce((sum, num) => sum + num, 0);
			var commonTabUIWidthTotal = commonTabUIWidthSum + commonTabUIWidthList.length * 21 + 15;
			if (commonTabUIWidthTotal >= 344) {
				$(this).css({"width": commonTabUIWidthTotal + "px"});
			} else {
				$(this).css({"width": "auto"});
				$(this).parent(".spComTab").addClass("is-active");
			}
		});
		$('.foormap .spComTab > .comTabUl').each(function(){
			var commonTabUIWidthList = new Array();
			$(this).children().each(function(index){
				commonTabUIWidthList[index] = $(this).width();
			});
			var commonTabUIWidthSum = commonTabUIWidthList.reduce((sum, num) => sum + num, 0);
			var commonTabUIWidthTotal = commonTabUIWidthSum + commonTabUIWidthList.length * 21 + 15;
			if (commonTabUIWidthSum >= 344) {
				$(this).css({"width": commonTabUIWidthTotal + "px"});
			} else {
				$(this).css({"width": "auto"});
				$(this).parent(".spComTab").addClass("is-active");
			}
		});
        $('.spComTab.js_blog_taggs > ul').each(function(){
			var commonTabUIWidthList = new Array();
			$(this).children().each(function(index){
				commonTabUIWidthList[index] = $(this).width();
			});
			var commonTabUIWidthSum = commonTabUIWidthList.reduce((sum, num) => sum + num, 0);
			var commonTabUIWidthTotal = commonTabUIWidthSum + commonTabUIWidthList.length * 21 + 15;
			$(this).css({"width": commonTabUIWidthTotal + "px"});
		});
        $('.spComTab').scroll(function() {
			var $comTabScroll =  $(this).scrollLeft();
			if ($comTabScroll > 0) {
				$(this).addClass("is-active");
			} else {
				$(this).removeClass("is-active");
			}
		});
	}
});

$(window).bind("load", function () {
	$footerTel = $(".comContact .tel a");
    if (document.URL.match("JEWELRY") || document.URL.match("BRIDAL") || document.URL.match("EYE")) {
		$footerTel.text("087-864-5775");
		$footerTel.attr("href", "tel:0878645775");
	}
});

$(function(){
    $footerTel = $(".comContact .tel a");
	$(document).on('click', '.boost-sd__filter-option-item-button', function() {
		var $txt = $(this).children(".boost-sd__filter-option-item-label").text();
		if ($txt == "WATCH") {
			$footerTel.text("087-864-5225");
			$footerTel.attr("href", "tel:0878645225");
		} else {
			$footerTel.text("087-864-5775");
			$footerTel.attr("href", "tel:0878645775");
		}
	});
	$(document).on('click', '.boost-sd__button--clear[aria-label="Clear filter by ジャンル"], .boost-sd__button--clear[aria-label="Clear all filters"]', function() {
		$footerTel.text("087-864-5225");
		$footerTel.attr("href", "tel:0878645225");
	});
	$(document).on('click', '.boost-sd__filter-tree-vertical-refine-by-item', function() {
		var $txt = $(this).find(".boost-sd__filter-tree-vertical-refine-by-option").text();
		console.log($txt);
		if ($txt == "ジャンル: ") {
			$footerTel.text("087-864-5225");
			$footerTel.attr("href", "tel:0878645225");
		}
	});

	$('.js-search').click(function() {
		$(this).next().toggleClass("on");
		$("#gHeader").toggleClass("is-search");

		if ($(this).hasClass("on")) {
			$(this).removeClass("on");
			$("#gHeader").removeClass("is-search");
		}
	});

	$(".js-search-close").click(function() {
        $(".searchFixed").removeClass("on");
		$("#gHeader").removeClass("is-search");
	});
});